module.exports = __webpack_public_path__ + "media/snacks/no-treats-c923d246.svg";